import script from "./BookingView.vue?vue&type=script&setup=true&lang=js"
export * from "./BookingView.vue?vue&type=script&setup=true&lang=js"

import "./BookingView.vue?vue&type=style&index=0&id=04e89624&lang=scss"

const __exports__ = script;

export default __exports__